import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { actionChangeAppProps } from "../../actions/AppAction";
import { actionLogOut } from "../../actions/AuthActions";
import AppBar from "material-ui/AppBar";
import logo from "../../common/assets/logo-wide-whiteBO.png";

class HeaderBO extends Component {
	onLogout() {
		this.props.actionLogOut(() => {
			this.Logout();
		});
	}
	Logout() {
		this.props.actionLogOut(this.logOutSuccess);
	}

	logOutSuccess() {
		//	this.props.history.push(LOGIN);
	}
	render() {
		const styles = {
			title: {
				marginLeft: this.props.hideDrawer ? 265 : 0,
				padding: 3,
				height: 30
			},
			titleIMG: {
				marginRight: 10,
				padding: 3,
				height: 30,
				marginTop: "-4px"
			},
			appBar: {
				position: "fixed",
				//top: 0,
				backgroundColor: "#2d5986",
				alignItems: "center"
			},
			leftIcon: {
				marginLeft: 0,
				display: this.props.login ? "block" : "none"
			}
		};

		return (
			<AppBar
				style={styles.appBar}
				onLeftIconButtonTouchTap={this.props.leftIconClick}
				iconStyleLeft={{
					display: this.props.login ? "block" : "none",
					marginLeft: 5,
					marginRight: 0,
					marginTop: 0
				}}
				titleStyle={styles.title}
				title={"Sistema de Administración Sindical"}
				iconElementRight={
					<img
						src={logo}
						className="App-logo"
						alt="caster"
						style={{
							//width: "150px",
							height: "37px"
						}}
					/>
				}
				iconStyleRight={styles.titleIMG}
			/>
		);
	}
}

function mapStateToProps(store) {
	return {
		login: store.session.authenticated,
		email: store.session.user
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionChangeAppProps,
			actionLogOut
		},
		dispatch
	);
}
export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(HeaderBO)
);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderBO.js